<template>
  <div>
    <button
      id="id-unassign-convo-btn"
      type="button"
      class="btn btn-rounded btn-block mt-1 bg-info text-white"
      :disabled="httpPending"
      @click.prevent="unassignConversation()"
      >
        <i v-if="httpPending" class="fa fa-spinner fa-spin"></i>
        Unassign {{ currentConversation.operator_id === currentUser.user_id ? 'Myself' : currentConversation.operator_name }}
    </button>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  props: {
    conversationId: String
  },
  data() {
    return {
      httpPending: false,
    };
  },
  computed: {
    ...mapGetters("agency", ["currentAgencyId"]),
    ...mapState({
      currentUser: (state) => state.user.user,
      currentConversation: (state) => state.conversations.currentConversation.conversation
    }),
  },
  methods: {
    async unassignConversation() {
      if (confirm("Are you sure you want to unassigned this conversation thread?")) {
        this.httpPending = true;
        try {
          const resp = await this.$ConveyApi.conversationsApi.unassignAgentFromConversation({
            conversationId: this.conversationId,
            userId: this.currentUser.user_id,
          });

          if (resp.status <= 200) {
            if (resp.status == 200) {
              this.$router.push({path: `/conversations/${this.conversationId}`}).catch(()=>{});
              this.$toastr("success", "Conversation Unassigned");
            }
            this.httpPending = false;
            return true;
          } else {
            this.$toastr("error", `Error Unassigning Conversation (${resp.status})`);
            this.httpPending = false;
            return false;
          }
        } catch (error) {
          this.$toastr("error", "Error Unassigning Conversation");
          this.httpPending = false;
          return false;
        }
      }
    },
  },
};
</script>
